module.exports = __webpack_public_path__ + "static/logo-1a05c3f4da1b0ba28cef51d938aa5e2a.png";